import {
    buildActionCreators,
    makeActionTypes,
    makeAsyncEvents,
    singleParameter,
} from '/b2b/common/helpers/ReduxHelpers';

import { DOMAIN } from './RequestDetails.constants';

export const events = {
    setActionItems: singleParameter,
    setActionItemsCreating: singleParameter,
    setActionItemsLoading: singleParameter,
    setAuditEvents: singleParameter,
    setAuditEventsLoading: singleParameter,
    setDataStoresLoading: singleParameter,
    setEmailNotificationSent: singleParameter,
    setHasDataStores: singleParameter,
    setRejectionReasons: singleParameter,
    setRejectionReasonsLoading: singleParameter,
    setSummaries: singleParameter,
    setSummariesLoading: singleParameter,
    setSummariesPackaging: singleParameter,
    setViewedStatus: singleParameter,
};

export const asyncEvents = makeAsyncEvents(['fetchDetails', 'updateRequestDetails'], true);
export const statusEvents = makeAsyncEvents(['updateStatus'], true);

export const types = makeActionTypes(
    [...Object.keys(events), ...Object.keys(asyncEvents), ...Object.keys(statusEvents)],
    DOMAIN
);

export default buildActionCreators(
    {
        ...events,
        ...asyncEvents,
        ...statusEvents,
    },
    types
);
